import { render, staticRenderFns } from "./ProductStock.vue?vue&type=template&id=5f4b33e0&scoped=true"
import script from "./ProductStock.vue?vue&type=script&lang=js"
export * from "./ProductStock.vue?vue&type=script&lang=js"
import style0 from "./ProductStock.vue?vue&type=style&index=0&id=5f4b33e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4b33e0",
  null
  
)

export default component.exports